export interface IWarehouseAdminSimpleProductReportProductData {
    id: number;
    name: string|null;
    target_price: number|null;
    active: boolean;
    category: {
        id: number;
        name: string|null;
    }|null;
    last_stock_count: number;
    received_after_stock_count: number;
    delivered_after_stock_count: number;
    calculated_stock: number;
    history_90_days: number;
}

export interface IWarehouseAdminSimpleProductReportData {
    products: IWarehouseAdminSimpleProductReportProductData[];
}

export class WarehouseAdminSimpleProductReportProductData {
    id: number;
    name: string|null;
    target_price: number|null;
    active: boolean;
    category: {
        id: number;
        name: string|null;
    }|null;
    last_stock_count: number;
    received_after_stock_count: number;
    delivered_after_stock_count: number;
    calculated_stock: number;
    history_90_days: number;

    constructor(data: IWarehouseAdminSimpleProductReportProductData) {
        this.id = Number(data.id);
        this.name = data.name ?? null;
        this.target_price = data.target_price == null ? null : Number(data.target_price);
        this.active = Boolean(data.active);
        this.category = data.category ?? null;
        this.last_stock_count = Number(data.last_stock_count ?? 0);
        this.received_after_stock_count = Number(data.received_after_stock_count ?? 0);
        this.delivered_after_stock_count = Number(data.delivered_after_stock_count ?? 0);
        this.calculated_stock = Number(data.calculated_stock ?? 0);
        this.history_90_days = Number(data.history_90_days ?? 0);
    }
}

export default class WarehouseAdminSimpleProductReportData {
    products: WarehouseAdminSimpleProductReportProductData[];

    constructor(data: IWarehouseAdminSimpleProductReportData) {
        this.products = (data.products ?? []).map(
            product => new WarehouseAdminSimpleProductReportProductData(product)
        );
    }
}